import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import CheckBoxSelect from '../Select/CheckBoxSelect';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   checkbox: {
      fontFamily: `'DBHeavent', sans-serif `,
   },
   label: { fontFamily: `'DBHeavent', sans-serif ` },
}));
const CheckBoxGroup = (props) => {
   const classes = useStyles();
   const [parentCheckboxChecked, setParentCheckboxChecked] = useState(false);
   const handleParentCheckboxChange = (isChecked) => {
      const { checkboxes, onCheckboxGroupChange } = props;
      const newCheckState = checkboxes.map((aCheckbox) => ({
         ...aCheckbox,
         checked: isChecked,
      }));
      onCheckboxGroupChange(newCheckState);
   };
   useEffect(() => {
      updateParentWithChildren(props);
   });

   const updateParentWithChildren = (props) => {
      const { checkboxes } = props;
      let allChecked = false;
      for (let i = 0; i < checkboxes.length; i += 1) {
         if (checkboxes[i].checked) {
            allChecked = true;
         } else {
            allChecked = false;
            break;
         }
      }
      setParentCheckboxChecked(allChecked);
   };
   const handleChildCheckboxChange = (isChecked, index) => {
      const { checkboxes } = props;
      const { onCheckboxGroupChange } = props;
      const newCheckState = checkboxes.map((aCheckbox, i) =>
         index === i ? { ...aCheckbox, checked: isChecked } : aCheckbox,
      );
      onCheckboxGroupChange(newCheckState);
   };
   const renderCheckboxes = () => {
      const { checkboxes } = props;
      if (!checkboxes) {
         return null;
      }
      return checkboxes.map((aCheckbox, index) => (
         <CheckBoxSelect
            disabled={aCheckbox.disabled || props.disabledAll}
            key={index}
            checkboxLabel={aCheckbox.label}
            checkboxValue={aCheckbox.value}
            checked={aCheckbox.checked}
            size={'small'}
            checkboxChangeCallback={(checkStatus) =>
               handleChildCheckboxChange(checkStatus, index)
            }
         />
      ));
   };
   return (
      <Box>
         <CheckBoxSelect
            disabled={props.disabledAll}
            checkboxLabel={props.title}
            checkboxValue='allBO'
            checked={parentCheckboxChecked}
            checkboxChangeCallback={handleParentCheckboxChange}
         />
         <Divider />
         <Box
            p={2}
            display='flex'
            flexDirection='column'
            className='checkbox-children'
         >
            {renderCheckboxes()}
         </Box>
      </Box>
   );
};

export default CheckBoxGroup;
